import { type App } from 'vue'
import AppBadge from './app-badge.vue'
import AppButton from './app-button.vue'
import AppButtonBack from './app-button-back.vue'
import AppCheckbox from './app-checkbox.vue'
import AppEmpty from './app-empty.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppFilterBar from './app-filter-bar.vue'
import AppInput from './app-input.vue'
import AppInputNumber from './app-input-number.vue'
import AppInputPassword from './app-input-password.vue'
import AppNotice from './app-notice.vue'
import AppPagination from './app-pagination.vue'
import AppRouterView from './app-router-view.vue'
import AppSearch from './app-search.vue'
import AppSelect from './app-select.vue'
import AppSubmit from './app-submit.vue'
import AppTabStatus from './app-tab-status.vue'
import AppTabStatusItem from './app-tab-status-item.vue'
import Card from './card'
import AppDatePicker from './datepicker/app-date-picker.vue'
import AppDateRangePicker from './datepicker/app-date-range-picker.vue'
import Dropdown from './dropdown'
import FaIcon from './fa-icon.vue'
import Modal from './modal'
import AppPageFilter from './page-filter'
import RainProductCode from './rain-product-code.vue'
import AppTable from './table/app-table.vue'
import AppTableCheckable from './table/app-table-checkable.vue'

export default {
  install (app: App) {
    app.component('AppBadge', AppBadge)
    app.component('AppButton', AppButton)
    app.component('AppButtonBack', AppButtonBack)
    app.component('AppCheckbox', AppCheckbox)
    app.component('AppDatePicker', AppDatePicker)
    app.component('AppDateRangePicker', AppDateRangePicker)
    app.component('AppEmpty', AppEmpty)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppFilterBar', AppFilterBar)
    app.component('AppInput', AppInput)
    app.component('AppInputNumber', AppInputNumber)
    app.component('AppInputPassword', AppInputPassword)
    app.component('AppNotice', AppNotice)
    app.component('AppPagination', AppPagination)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSearch', AppSearch)
    app.component('AppSelect', AppSelect)
    app.component('AppSubmit', AppSubmit)
    app.component('AppTable', AppTable)
    app.component('AppTableCheckable', AppTableCheckable)
    app.component('AppTabStatus', AppTabStatus)
    app.component('AppTabStatusItem', AppTabStatusItem)
    app.component('FaIcon', FaIcon)
    app.component('RainProductCode', RainProductCode)
    app.use(Modal)
    app.use(Card)
    app.use(Dropdown)
    app.use(AppPageFilter)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppBadge: typeof AppBadge,
    AppButton: typeof AppButton,
    AppButtonBack: typeof AppButtonBack,
    AppCheckbox: typeof AppCheckbox,
    AppDatePicker: typeof AppDatePicker,
    AppDateRangePicker: typeof AppDateRangePicker,
    AppEmpty: typeof AppEmpty,
    AppErrorMsg: typeof AppErrorMsg,
    AppFilterBar: typeof AppFilterBar,
    AppInput: typeof AppInput,
    AppInputNumber: typeof AppInputNumber,
    AppInputPassword: typeof AppInputPassword,
    AppNotice: typeof AppNotice,
    AppPagination: typeof AppPagination,
    AppRouterView: typeof AppRouterView,
    AppSearch: typeof AppSearch,
    AppSelect: typeof AppSelect,
    AppSubmit: typeof AppSubmit,
    AppTable: typeof AppTable,
    AppTableCheckable: typeof AppTableCheckable,
    AppTabStatus: typeof AppTabStatus,
    AppTabStatusItem: typeof AppTabStatusItem,
    FaIcon: typeof FaIcon,
    RainProductCode: typeof RainProductCode,
  }
}
